import { fetchUtils, GET_ONE } from "react-admin";

const initCandidatePracticeAssessmentsProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_ONE:
        return httpClient(
          `${apiUrl}/candidates/${params.id}/practice-assessments`
        ).then((response) => ({
          data: { id: params.id, ...response.json },
        }));
      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initCandidatePracticeAssessmentsProvider;